import { render, staticRenderFns } from "./authorMonitoring.vue?vue&type=template&id=0eda0070&scoped=true"
import script from "./authorMonitoring.vue?vue&type=script&lang=js"
export * from "./authorMonitoring.vue?vue&type=script&lang=js"
import style0 from "./authorMonitoring.vue?vue&type=style&index=0&id=0eda0070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda0070",
  null
  
)

export default component.exports